/* import $api from '../api'; */
import { $api } from '../api'

import { ICustomer, ILegalData, IUser } from 'dto/users.dto'
import {
  buildCustomersQueryParamsObject,
  ICustomersListQuery,
} from 'handlers/buildCustomersQueryParams'
import {
  extractPhoneDigits,
  normalizeEmail,
} from 'handlers/normalizeContactSearch'

export interface IAdminPasswordResult {
  emailSent: boolean
  message: string
}

export type { ICustomersListQuery }

export default class UsersService {
  //получаем всех пользователей
  static async getAllUsers(): Promise<{ data: IUser[] }> {
    return $api.get('/admins')
  }
  //создание пользователя
  static async createUser(data: IUser): Promise<{ data: IUser }> {
    return $api.post('/admins/new', data)
  }
  //редактирование
  static async editUserById(data: IUser): Promise<{ data: IUser }> {
    return $api.put(`/admins`, data)
  }
  //создание данных юрлица
  static async createLegalData(
    data: ILegalData
  ): Promise<{ data: ILegalData }> {
    return $api.post(`/legal`, data)
  }
  //обновление данных юрлица
  static async editLegalData(data: ILegalData): Promise<{ data: ILegalData }> {
    return $api.put(`/legal`, data)
  }

  /**
   * Загружает клиентов с фильтрами, сортировкой и пагинацией.
   * @param query — query-параметры списка клиентов
   */
  static async getAllCustomers(
    query?: ICustomersListQuery
  ): Promise<{ data: ICustomer[]; total: number }> {
    const normalizedQuery: ICustomersListQuery | undefined = query
      ? {
          ...query,
          email: query.email ? normalizeEmail(query.email) : query.email,
          phone: query.phone
            ? extractPhoneDigits(query.phone) || undefined
            : query.phone,
        }
      : query
    const params = buildCustomersQueryParamsObject(normalizedQuery)
    const response = await $api.get(`/users`, { params })
    const payload = response?.data
    if (Array.isArray(payload)) {
      return { data: payload, total: payload.length }
    }
    return {
      data: Array.isArray(payload?.data) ? payload.data : [],
      total: typeof payload?.total === 'number' ? payload.total : 0,
    }
  }

  /**
   * Загружает клиентов пиццерии с пагинацией (legacy; страница customers больше не использует).
   * @param id — id пиццерии
   * @param pagination — limit и offset
   */
  static async getUsersByPizzeriaId(
    id: number,
    pagination?: { limit: number; offset: number }
  ): Promise<{ data: ICustomer[]; total: number }> {
    const params = pagination
      ? `?limit=${pagination.limit}&offset=${pagination.offset}`
      : ''
    const response = await $api.get(`/users/pizzeria/${id}${params}`)
    const payload = response?.data
    if (Array.isArray(payload)) {
      return { data: payload, total: payload.length }
    }
    return {
      data: Array.isArray(payload?.data) ? payload.data : [],
      total: typeof payload?.total === 'number' ? payload.total : 0,
    }
  }

  /**
   * Задаёт пароль клиента от имени администратора.
   * @param userId — id клиента
   * @param password — новый пароль
   */
  static async adminSetCustomerPassword(
    userId: number,
    password: string
  ): Promise<IAdminPasswordResult> {
    const response = await $api.put<
      { password: string },
      { data: IAdminPasswordResult }
    >(`/users/${userId}/password`, { password })
    return response?.data
  }

  /**
   * Удаляет пароль клиента от имени администратора.
   * @param userId — id клиента
   */
  static async adminClearCustomerPassword(
    userId: number
  ): Promise<IAdminPasswordResult> {
    const response = await $api.delete(`/users/${userId}/password`)
    return response?.data
  }
}
